import React from 'react'
import styles from './PublishComponent.scss'
import { RenderPages } from './RenderPages'

export const RenderMagazine = ( props ) => {
  const { background, pages, actualPage, onNavigation, scaleFactor, start } = props
  const navLeftClass = `${styles.nav} ${styles['nav-left']} basic-button`
  const navRightClass = `${styles.nav} ${styles['nav-right']} basic-button`

  return (
    <div className={styles.preview}
      style={background}
      ref={props.setRef}>

      {pages.length &&
          <React.Fragment>
            {actualPage > 1 &&
            <button className={navLeftClass} onClick={() => onNavigation( 'previous' )}>
              <i className="material-icons">chevron_left</i>
            </button> }
            {actualPage < pages.length &&
            <button className={navRightClass} onClick={() => onNavigation( 'next' )}>
              <i className="material-icons">chevron_right</i>
            </button>
            }
          </React.Fragment>
        }
        
      <div className={styles['magazine-container']}>

        <div className={styles['pages-container']}>

          <div id="pages" className={styles.pages}>
            <RenderPages pages={pages} scaleFactor={scaleFactor} start={start} />
          </div>

        </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/publish/RenderMagazine.js